var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInforormationUnactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39384 0.471191L9.60893 1.77034V22L8.39384 20.7008V0.471191ZM0 7.52383H1.35381C2.2883 5.74598 3.93921 4.34396 5.96335 3.63231V15.5977L7.17843 16.8968V2.42052L7.1783 2.42059V2.14156C3.91419 2.70908 1.2278 4.77225 0 7.52383ZM8.39343 19.7849H8.39339V18.6486L8.39343 18.6486V19.7849ZM18.0023 7.52383H16.6485C15.714 5.7459 14.063 4.34383 12.0387 3.63222V14.6692L10.8236 13.37V3.29884L10.8236 3.29884V2.14149C14.0879 2.7089 16.7745 4.77213 18.0023 7.52383ZM8.3934 3.13865L8.39346 3.13865V2.00231L8.3934 2.00231V3.13865Z",
    fill: "#968E53"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInforormationUnactive);
export default __webpack_public_path__ + "static/media/icon-inforormation-unactive.fe2a5344.svg";
export { ForwardRef as ReactComponent };